import Preview from './Preview'
import AgainPhoneDialog from './AgainPhoneDialog'
import { createPopup } from '@/assets/js/factory'
import { investigatorMixin } from 'dygc'


export default {
  name: 'InvestigatorEdit',
  extends: Preview,
  mixins: [investigatorMixin],
  computed: {
    editSubmit: () => true
  },
  watch: {
    againPhone(val) {
      if(val) {
        this.createAgainDialog()
      } else {
        this.closeInvestigatorEdit()
      }
    }
  },
  methods: {
    // 关闭编辑弹窗
    closeInvestigatorEdit() {
      if (window.top && window.top !== window) {
        window.top.postMessage(JSON.stringify({ message: 'closeEdit' }), '*')
      }
    },
    // 创建手机号重复提示弹窗
    createAgainDialog() {
      const vm = createPopup(AgainPhoneDialog)
      vm.$on('closeInvestigatorEdit', () => {this.closeInvestigatorEdit()})
      vm.$on('investigatorEdit', () => {this.investigatorEdit(vm.nullValueRule, vm.differentValueRule)})
    },
  }
}
